<template>
  <div class="heading">
    <img style="float: left; position: absolute" class="missionImage" v-if="front_image != null" :src="front_image"/>
    <div style="font-size: larger; color: rgba(187,0,0,0.85); font-family: 'Old Stamper'; text-align: right">{{ missionStatus[mission_status] }}</div>
    <div style="text-align: center">"{{ name }}" <br> {{ hist_date }} <br> ({{ real_date }})</div>
  </div>
</template>

<script>
import statConv from "../../resource/statusConverter"

export default {
  name: "MissionHeader",
  mixins: [statConv],
  props: {
    id: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    real_date: {
      type: String,
      default: null
    },
    hist_date: {
      type: String,
      default: null
    },
    mission_status: {
      type: Number,
      default: null
    },
    front_image: {
      type: String,
      default: null
    }
  },
}
</script>

<style scoped>

.missionImage{
  height: 126px;
  width: 200px;
  border-radius: 15px;
  box-shadow: 5px 5px 5px rgba(5,5,5,0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/MissionHeader.vue